module.exports = __webpack_public_path__ + "img/biletalllogo.91c8eca2.png";